import format from 'date-fns/format'

export const getArticleFormattedDateTime = (
  date,
  outputformat = 'MMM DD, YYYY'
) => {
  let readableDate = date
  if (!date) return null
  try {
    readableDate = format(date, outputformat)
  } catch (error) {
    console.log(error)
  }
  return readableDate
}



// WEBPACK FOOTER //
// ./src/utils/DateUtils.js